import {memo} from 'react'
import {useIsRecording} from '@livekit/components-react'

/**
 * Recording indicator shown to all participants when the room is being recorded.
 * Uses LiveKit's useIsRecording() — the server pushes this state to every client.
 */
export const RecordingIndicator = memo(function RecordingIndicator() {
  const isRecording = useIsRecording()

  if (!isRecording) return null

  return (
    <div
      className="flex items-center gap-2 rounded-full border border-destructive/30 bg-destructive/10 px-3 py-1.5 text-xs font-medium text-destructive sm:px-4 sm:py-2 sm:text-sm"
      aria-live="polite"
      aria-label="Идёт запись звонка"
    >
      <span className="relative flex size-2">
        <span className="absolute inline-flex size-full animate-ping rounded-full bg-destructive opacity-75" />
        <span className="relative inline-flex size-2 rounded-full bg-destructive" />
      </span>
      <span>Запись</span>
    </div>
  )
})
